import { TbKey } from "react-icons/tb";
import { Input } from "../../../components/Input";
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form';
import { z } from 'zod'
import { useAuth } from "../../../hooks/useAuth";

import { LoginMFAContainer, LoginMFAHeader, LoginMFAButton, LoginMFAActions, ResendButton, WaitMessage } from "./styles";
import { TfiReload } from "react-icons/tfi";
import { useState } from "react";
import { toast } from "react-toastify";

const loginMFASchema = z.object({
  otp: z.string().max(6, 'O campo Código aceita no máximo 6 digitos.'),
})

export const LoginMFA = () => {
  const { setStep, resendLogin2FA ,login2FA, phone } = useAuth();
  const [countdown, setCountdown] = useState(0);
  
  const { 
    register, 
    handleSubmit, 
    formState: { errors, isSubmitting } 
  } = useForm({
    resolver: zodResolver(loginMFASchema)
  })

  async function handle2FA(data) {
    await login2FA(data.otp);
  }

  const returnStep = () => {
    setStep(1);
  };

  const resendButtonClick = (type) => {
    setCountdown(30);
    resendLogin2FA(type);

    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          clearInterval(interval);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);
  }
  
  return (
    <LoginMFAContainer>
      <LoginMFAHeader>
        <h3>Autenticação de 2 fatores</h3>
        <p>Enviamos um código SMS para {phone}.</p>
      </LoginMFAHeader>

      <form onSubmit={handleSubmit(handle2FA)}>
        <Input  
          type="text"
          label="Código"
          icon={<TbKey />}
          maxLength={6}
          onlyNumber
          register={register('otp')}
          />
          <ResendButton type="button" onClick={() => resendButtonClick('sms')} disabled={countdown > 0}>
            <TfiReload />
            Reenviar Código
          </ResendButton>
          <ResendButton type="button" onClick={() => resendButtonClick('email')} disabled={countdown > 0}>Não recebeu o SMS? Receber código por e-mail</ResendButton>
        {countdown > 0 && <WaitMessage>Por favor, espere {countdown} segundos para reenviar</WaitMessage>}
        {errors.otp && <span>{errors.otp.message}</span>}

        <LoginMFAActions>
          <LoginMFAButton type={'button'} onClick={returnStep} disabled={isSubmitting}>Voltar</LoginMFAButton>
          <LoginMFAButton type={'submit'} disabled={isSubmitting}>
            {isSubmitting ? 'Entrando...' : 'Entrar'}
          </LoginMFAButton>
        </LoginMFAActions>
      </form>
    </LoginMFAContainer>
  )
}